// extracted by mini-css-extract-plugin
export default {"container":"_3Pxy-4","tablist":"_3I0cj9","tab":"_1xwRpA","selected":"_3pOgcL","tabpannel":"_11vEMW","selectedTabPanel":"_1FMc0Z"};